var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cars.length)?_c('div',{staticClass:"rating"},[_c('div',{staticClass:"head"},[_vm._v("\n        "+_vm._s(_vm.$t('Відгуки про'))+" авто\n    ")]),_c('div',{staticClass:"inner-rating"},_vm._l((_vm.cars),function(car){return _c('car-review',{key:car.name,attrs:{"data":car},on:{"sendChildLogsEvent":_vm.passLogsEvent}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }